<div>

    <div class="heading-tab">
        <h3 class="heading"><i nz-icon nzType="profile" nzTheme="outline"></i> Bill details</h3>
    </div>

    <nz-table [nzData]="[1,2]" [nzShowPagination]="false" [nzScroll]="{ x: '1700px' }" class="table-valign-top">
        <thead>
        <tr>
            <th></th>
            <th style="width: 230px">Bill Head</th>
            <th>Bill Number</th>
            <th>Bill Date</th>
            <th>Bill Amount</th>
            <th>Co-Payment Amount</th>
            <th>Admissible Amount</th>
            <th>Disallowed Amount</th>
            <th>Approved Amount</th>
            <th>Payable Amount</th>
            <th style="width: 200px">Remarks</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let r of rows; let i=index;">
            <td data-dd="Actions">
                <div *ngIf="i==0">
                    <button nz-button nzType="dashed" (click)="addRow()">
                        <i nz-icon nzType="plus"  nzTheme="outline"></i>
                    </button>
                </div>
                <div *ngIf="i>0">
                    <button nz-button nzType="dashed" nz-popconfirm 
                    nzPopconfirmTitle="Remove row?" nzOkText="Remove" nzCancelText="Cancel" (nzOnConfirm)="removeRow()">
                        <i nz-icon nzType="delete" nzTheme="outline"></i>
                    </button>
                </div>
            </td>
            <td data-dd="Bill Type">
                <nz-select nzShowSearch  style="width:100%;display: block" [ngModel]="1">
                    <nz-option *ngFor="let i of billTypesAllowed" [nzLabel]="i.name" [nzValue]="i.id"></nz-option>
                </nz-select>
                <!-- Bill Scan upload -->
                <div *ngIf="i==0" class="d-b m-t-20">
                    <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" [nzFileList]="fileList">
                        <button nz-button><i nz-icon nzType="upload"></i><span>Upload</span></button>
                    </nz-upload>
                </div>
            </td>
            <td data-dd="Bill Number">
                <input type="text" nz-input />
            </td>
            <td data-dd="Bill Date">
                <nz-date-picker style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </td>
            <td data-dd="Bill Amt">
                <input type="text" nz-input />
            </td>
            <td data-dd="Co-Payment Amount">
                <input type="text" nz-input />
            </td>
            <td data-dd="Admissible Amount">
                <input type="text" nz-input />
            </td>
            <td data-dd="Disallowed Amount">
                <input type="text" nz-input />
            </td>
            <td data-dd="Approved Amount">
                <input type="text" nz-input />
            </td>
            <td data-dd="Payable Amount">
                <input type="text" nz-input />
            </td>
            <td data-dd="Remarks">
                <textarea nz-input cols="2" rows="2" placeholder="Remarks ..."></textarea>
            </td>
        </tr>
        <tr>
            <td data-dd="Actions">
            </td>
            <td data-dd="Bill Type">
            </td>
            <td data-dd="Bill Number">
            </td>
            <td data-dd="Bill Date">
            </td>
            <td data-dd="Bill Amt">
                <span class="f-s-1-4r col-red">
                    Rs. 
                  <span [(countUp)]="totalBillAmount" [reanimateOnClick]="false">
                  </span>
                  </span>
            </td>
            <td data-dd="Co-Payment Amount">
            </td>
            <td data-dd="Admissible Amount">
            </td>
            <td data-dd="Disallowed Amount">
            </td>
            <td data-dd="Approved Amount">
            </td>
            <td data-dd="Payable Amount">
            </td>
            <td data-dd="Remarks">
            </td>
        </tr>
        <tr>
            <td data-dd="Actions">
            </td>
            <td data-dd="Bill Type">
            </td>
            <td data-dd="Bill Number">
            </td>
            <td data-dd="Bill Date">
            </td>
            <td data-dd="Bill Amt">
                <b>Total Claimed Amount</b>
            </td>
            <td data-dd="Co-Payment Amount">
                <b>Total Co-Payment Amount</b>
            </td>
            <td data-dd="Admissible Amount">
                <b>Total claimed amount</b>
            </td>
            <td data-dd="Disallowed Amount">
                <b>Total Disallowed Amount</b>
            </td>
            <td data-dd="Approved Amount">
                <b>Total Approved Amount</b>
            </td>
            <td data-dd="Payable Amount">
            </td>
            <td data-dd="Remarks">
            </td>
        </tr>
        </tbody>
    </nz-table>
</div>